import { gtEstiPro } from '@trwl/app/fonts';
import { Container } from '@trwl/layout';
import { Path } from '@trwl/shared/lib/router';
import { Button } from '@trwl/shared/ui/button';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

export const NewUserBonusesBlock = () => {
  return (
    <div className="w-full relative">
      <Container>
        <div className="flex flex-row items-center justify-between min-h-[280px]">
          <div
            className={cn(
              gtEstiPro.className,
              'text-[36px] lg:text-[46px] xl:text-[52px] text-white grow-1 py-4',
            )}
          >
            <p>
              Дарим <b>500 рублей</b>
            </p>
            <p>новичкам за регистрацию!</p>
            <Button
              as={Link}
              href={Path.BONUSES}
              size="lg"
              radius="sm"
              color="default"
              className="whitespace-nowrap w-[220px] max-[400px]:w-[160px] bg-white mt-8"
            >
              Получить бонусы
            </Button>
          </div>
          <Image
            src={
              'https://storage.yandexcloud.net/trwl-static/site/newUserBlock.png'
            }
            className={'hidden lg:block'}
            alt={'newUserBlock'}
            width={452}
            height={312}
            loading={'lazy'}
          />
          <Image
            src={
              'https://storage.yandexcloud.net/trwl-static/site/newUserBlock_mob.png'
            }
            className={'lg:hidden translate-x-[100px]'}
            alt={'newUserBlock'}
            width={434}
            height={384}
            loading={'lazy'}
          />
        </div>
      </Container>
      <div className="bg-[#241A1B] absolute inset-0 w-screen left-1/2 -translate-x-1/2 h-full pointer-events-none -z-10" />
    </div>
  );
};
